import { render, staticRenderFns } from "./bindOrder.vue?vue&type=template&id=824f49e4&scoped=true&"
import script from "./bindOrder.vue?vue&type=script&lang=js&"
export * from "./bindOrder.vue?vue&type=script&lang=js&"
import style0 from "./bindOrder.vue?vue&type=style&index=0&id=824f49e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824f49e4",
  null
  
)

export default component.exports